import React from "react";
import useSWR from "swr";
import { fetchGroupChats } from "@/repositories/groupChat";
import { UsersIcon } from "@heroicons/react/24/solid";
import Link from "next/link";
import { format, fromUnixTime } from "date-fns";

export const GroupChats = () => {
  const { data } = useSWR(`/api/v1/group_chats`, (url) => fetchGroupChats(url));

  return (
    <nav className="min-h-0 flex-1 overflow-y-auto" aria-label="Directory">
      {data?.length ? (
        <ul role="list" className="relative">
          {data?.map((group_chat) => (
            <li key={group_chat.id}>
              <Link
                href={`/app/online_consultation/${group_chat.id}`}
                className="border-b flex items-center space-x-3 px-6 py-3 focus-within:ring-2 focus-within:ring-inset focus-within:ring-blue-500 hover:bg-gray-50"
              >
                <div className="flex items-center justify-center flex-shrink-0 w-10 h-10 rounded-full bg-gray-100">
                  <UsersIcon className={"w-6 fill-blue-500"} />
                </div>
                <div className={"flex-1"}>
                  <p className="text-sm font-medium text-gray-900 flex-1">
                    {group_chat.title}
                  </p>
                  <p className="truncate text-[11px] text-gray-500 mt-1">
                    更新：
                    {format(
                      fromUnixTime(group_chat.updated_at),
                      "yyyy年M月d日 H:mm"
                    )}
                  </p>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      ) : (
        <p className={"text-center py-10 text-sm"}>チャットはまだありません</p>
      )}
    </nav>
  );
};
